module.exports = __webpack_public_path__ + "img/share-icon.4dc5c70e.svg";